var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.219 15.421C17.0801 15.4071 16.9134 15.4071 16.7606 15.421C13.4551 15.3099 10.8301 12.6016 10.8301 9.26823C10.8301 5.86545 13.5801 3.10156 16.9967 3.10156C20.3995 3.10156 23.1634 5.86545 23.1634 9.26823C23.1495 12.6016 20.5245 15.3099 17.219 15.421Z",
    stroke: "#40196D",
    strokeWidth: 2.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2747 20.5469C6.91363 22.7969 6.91363 26.4635 10.2747 28.6997C14.0942 31.2552 20.3581 31.2552 24.1775 28.6997C27.5386 26.4497 27.5386 22.783 24.1775 20.5469C20.372 18.0052 14.1081 18.0052 10.2747 20.5469Z",
    stroke: "#40196D",
    strokeWidth: 2.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.3813e48174ce3c9ff3f72556feafc2e9.svg";
export { ForwardRef as ReactComponent };